<span [matTooltip]="tooltipLeft | translate">
    <app-button
        (buttonClick)="previousValue()"
        [disabled]="disableLeft"
        icon="chevron-left"
        iconButton
        aria-label="Previous"
    >
    </app-button>
</span>
<div class="content-container">
    <ng-content></ng-content>
</div>
<span [matTooltip]="tooltipRight | translate">
    <app-button
        (buttonClick)="nextValue()"
        [disabled]="disableRight"
        icon="chevron-right"
        iconButton
        aria-label="Next"
    >
    </app-button>
</span>
